import { render, staticRenderFns } from "./SalesFlashTable.vue?vue&type=template&id=3e7ffb9c&scoped=true&"
import script from "./SalesFlashTable.vue?vue&type=script&lang=js&"
export * from "./SalesFlashTable.vue?vue&type=script&lang=js&"
import style0 from "./SalesFlashTable.vue?vue&type=style&index=0&id=3e7ffb9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7ffb9c",
  null
  
)

export default component.exports